import { createFileRoute } from "@tanstack/react-router";
import { DrehvorbereitungBearbeiten } from "@/pages/team/DrehvorbereitungBearbeiten";

/**
 * Die Team-Fassung der Drehvorbereitung — bearbeiten, KI-Varianten holen,
 * speichern. Bewusst GESCHÜTZT (unter `_angemeldet`): Externe bekommen nur
 * die geteilte Lese-Seite `/drehplan/$token` mit Kommentaren und
 * Unterschrift.
 */
export const Route = createFileRoute("/_angemeldet/_mitarbeiter/drehvorbereitung/$id")({
	component: Seite,
});

function Seite() {
	const { id } = Route.useParams();
	return <DrehvorbereitungBearbeiten verlaufId={id} />;
}
